import { AwsRum, AwsRumConfig } from "aws-rum-web";

let cachedRum: AwsRum | null = null;

export function initializeAwsRum(): AwsRum | null {
  if (cachedRum !== null) return cachedRum;

  const applicationId = import.meta.env.VITE_RUM_APPLICATION_ID;
  const applicationRegion = import.meta.env.VITE_RUM_APPLICATION_REGION;
  const identityPoolId = import.meta.env.VITE_RUM_IDENTITY_POOL_ID;
  const guestRoleArn = import.meta.env.VITE_RUM_GUEST_ROLE_ARN;

  if (!applicationId || !applicationRegion || !identityPoolId || !guestRoleArn) {
    console.warn("AWS RUM disabled — one or more VITE_RUM_* env vars missing");
    return null;
  }

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1.0,
      identityPoolId,
      endpoint: `https://dataplane.rum.${applicationRegion}.amazonaws.com`,
      telemetries: ["errors", "performance"],
      allowCookies: false,
      enableXRay: false,
      // WHY: aws-rum-web's auto-page-view captures window.location.href by default,
      // which includes querystring + hash. Form URLs may carry callback tokens or
      // tracking params (LGPD scope). disableAutoPageView keeps the bundle's
      // observability surface to the explicit `brand_hydration_latency` custom event
      // emitted by rumBrandHydration.ts. Errors + performance telemetries still ship.
      disableAutoPageView: true,
      guestRoleArn,
    };

    cachedRum = new AwsRum(applicationId, "1.0.0", applicationRegion, config);
    return cachedRum;
  } catch (err) {
    // WHY: RUM SDK init must never block app boot. If credential acquisition or
    // config validation throws, we want the SPA to still render and report via
    // Sentry — RUM unavailability is a degraded-observability event, not a P0.
    console.error("AWS RUM init failed", err);
    return null;
  }
}

export function getAwsRum(): AwsRum | null {
  return cachedRum;
}

export function __resetAwsRumForTests(): void {
  if (import.meta.env.PROD) {
    throw new Error("__resetAwsRumForTests is not callable in production");
  }
  cachedRum = null;
}
